import request from '@/api/http'
const card = {
    getCardList(params, callback) {
        return request.post(process.env.BASE_URL + `/employee/getEmployeeListByProject`, params, callback)
    },
}
export default card